module.exports = __webpack_public_path__ + "static/media/spiral.65541a20.png";